<template>
  <div>
    <data-table ref="dataTable" :option="option">
      <template slot="warehouse">
        <a-button type="primary" @click="addGoods">添加</a-button>
        <span style="margin-left:10px">{{ WarehouseGoodsName }}</span>
        <a-button type="link" v-if="WarehouseGoodsName" @click="deGoods"
          ><a-icon type="close"
        /></a-button>
      </template>
      <template slot="Img">
        <a-upload
          :action="actionUrl"
          listType="picture-card"
          :beforeUpload="beforeUpload"
          @change="onChange"
          :showUploadList="false"
        >
          <img
            :src="$config.serverUrl + '/' + ImageUrl"
            class="photo-img"
            v-if="ImageUrl"
          />

          <div class="ant-upload-box" v-else>
            <template>
              <a-icon type="plus" />
              <div class="ant-upload-text">上传图片</div>
            </template>
          </div>
        </a-upload>
      </template>
      <template #foodList>
        <FoodPackSelect ref="foodPackSelect" />
      </template>
      <template slot="rowPackAction" slot-scope="text, row">
        <div v-if="row.IsPack">
          <span>{{ text }}</span>
          <a @click="viewPackDetail(row)">（查看）</a>
        </div>
      </template>
    </data-table>
    <GoodsList ref="GoodsList" @submit="getGoods"></GoodsList>
  </div>
</template>
<script>
import { DataTable } from "@/components/dataTable";
import FoodPackSelect from "./foodPackSelect";
import viewFoodPackModal from "./viewFoodPackModal";
import GoodsList from "@/views/maintenance/components/GoodsList";
import cloneDeep from "lodash/cloneDeep";
const attributesData = [{ label: "可打折", value: 1 }];
export default {
  components: {
    DataTable,
    FoodPackSelect,
    GoodsList
  },
  data() {
    return {
      option: {},
      content: [
        {
          label: "编号",
          name: "Code",
          option: {
            rules: [{ required: true, message: "编号必填" }]
          }
        },
        {
          label: "名称",
          name: "Name",
          option: {
            rules: [{ required: true, message: "名称必填" }]
          }
        },
        {
          label: "售价",
          name: "Price",
          type: "number",
          option: {
            rules: [{ required: true, message: "售价必填" }]
          },
          props: {
            precision: 2
          }
        },
        {
          label: "会员价",
          name: "MemberPrice",
          type: "number",
          props: {
            precision: 2
          }
        },
        {
          label: "成本价",
          name: "CostPrice",
          type: "number",
          props: {
            precision: 2
          }
          // option: {
          //   rules: [{ required: true, message: "成本价必填" }]
          // }
        },

        {
          label: "单位",
          name: "UnitId",
          type: "select",
          api: "Common_GetSelect",
          param: { Types: "Unit" },
          dataField: "Data.Unit",
          option: {
            rules: [{ required: true, message: "单位必填" }]
          }
        },
        {
          label: "类别",
          name: "CategoryId",
          type: "select",
          api: "Common_GetSelect",
          param: { Types: "FoodCategory" },
          dataField: "Data.FoodCategory",
          option: {
            rules: [{ required: true, message: "请选择类别" }]
          }
        },

        {
          label: "排序",
          name: "Sort",
          type: "number",
          props: {
            min: 0
          }
        },
        {
          label: "状态",
          name: "Status",
          type: "switch"
        },
        {
          label: "属性",
          name: "Attributes",
          type: "checkbox-group",
          valueField: "value",
          data: attributesData
        },
        {
          label: "是否是套餐",
          name: "IsPack",
          type: "switch",
          onChange: val => {
            if (val) {
              this.$refs.foodPackSelect.show();
            } else {
              this.$refs.foodPackSelect.hide();
            }
          }
        },
        {
          label: "关联仓库物品",
          slot: "warehouse"
        },
        {
          label: " ",
          slot: "foodList",
          id: "foodListBox",
          colon: false,
          colnum: 2
        }
      ],
      editContent: [],
      actionUrl: "",
      ImageUrl: "",
      WarehouseGoodsId: "",
      WarehouseGoodsName: "",
      infoId: ""
    };
  },
  created() {
    this.editContent = cloneDeep(this.content);
    this.editContent.splice(10, 0, { label: "图片", slot: "Img", colnum: 2 });
    this.option = {
      headSearch: {
        colnum: 4,
        width: 900,
        content: [
          {
            label: "类别",
            name: "CategoryId",
            type: "select",
            api: "Common_GetSelect",
            param: { Types: "FoodCategory" },
            dataField: "Data.FoodCategory"
          },
          {
            label: "名称",
            name: "Name"
          },
          {
            label: "编号",
            name: "Code"
          },
          {
            label: "状态",
            name: "Status",
            type: "select",
            data: [
              {
                Id: "1",
                Text: "启用"
              },
              {
                Id: "0",
                Text: "禁用"
              }
            ]
          }
        ]
      },
      form: {
        title: "菜品",
        width: 800,
        colnum: 2,

        add: {
          submitApi: "AddFood",
          content: this.content,
          onOpenAfter: () => {
            let values = {
              Sort: "0",
              Status: true,
              IsPack: false,
              MemberPrice: 0,
              Attributes: [1]
            };
            this.WarehouseGoodsId = "";
            this.WarehouseGoodsName = "";
            this.ImageUrl = "";
            setTimeout(() => {
              this.$refs.foodPackSelect.hide();
              this.$refs.foodPackSelect.setData([]);
            }, 10);
            return values;
          },
          onSubmitBefore: values => {
            return this.onSubmitBefore(values);
          }
        },
        edit: {
          submitApi: "EditFood",
          content: this.editContent,
          onOpenAfter: values => {
            this.infoId = values.Id;
            this.ImageUrl = values.ImageUrl;
            values.Status = values.Status ? true : false;
            this.WarehouseGoodsId = values.WarehouseGoodsId;
            this.WarehouseGoodsName = values.WarehouseGoodsName;
            if (values.IsPack) {
              setTimeout(() => {
                this.$refs.foodPackSelect.show();
                this.$refs.foodPackSelect.setData(values.PackDetails);
              }, 10);
            } else {
              setTimeout(() => {
                this.$refs.foodPackSelect.hide();
                this.$refs.foodPackSelect.setData([]);
              }, 10);
            }
            let currentSelect = [];
            if (values.Attributes) {
              attributesData.forEach(el => {
                if ((values.Attributes | el.value) == values.Attributes) {
                  currentSelect.push(el.value);
                }
              });
            }
            values.Attributes = currentSelect;
            return values;
          },
          onSubmitBefore: values => {
            return this.onSubmitBefore(values);
          }
        },
        del: {
          submitApi: "DeleteFood"
        }
      },
      grid: {
        api: "GetFoodPage",
        props: {
          scroll: {
            x: 1750,
            y: "calc(100vh - 200px)"
          }
        },
        rowAction: false,
        columns: [
          {
            title: "序号",
            width: 60,
            align: "center",
            type: "indexcolumn"
          },
          {
            title: "类别",
            width: 120,
            dataIndex: "CategoryName"
          },

          {
            title: "编号",
            width: 120,
            dataIndex: "Code"
          },
          {
            title: "名称",
            width: 180,
            dataIndex: "Name"
          },
          {
            title: "关联仓库物品",
            width: 130,
            dataIndex: "WarehouseGoodsName"
          },
          {
            title: "是否套餐",
            width: 100,
            dataIndex: "IsPackName"
          },
          {
            title: "套餐菜品数",
            dataIndex: "PackDetailCount",
            width: 130,
            key: "PackDetailCount",
            scopedSlots: { customRender: "rowPackAction" }
          },
          {
            title: "属性",
            width: 150,
            dataIndex: "Attributes",
            customRender: text => {
              if (text) {
                let currentSelect = [];
                attributesData.forEach(el => {
                  if ((text | el.value) == text) {
                    currentSelect.push(el.label);
                  }
                });
                return currentSelect.join(", ");
              }
              return "";
            }
          },
          {
            title: "单位",
            width: 100,
            dataIndex: "UnitName"
          },
          {
            title: "售价",
            width: 100,
            dataIndex: "Price"
          },
          {
            title: "会员价",
            width: 100,
            dataIndex: "MemberPrice"
          },
          {
            title: "成本价",
            width: 100,
            dataIndex: "CostPrice"
          },
          {
            title: "状态",
            width: 120,
            dataIndex: "Status",
            customRender: text => {
              if (text) {
                return <a-badge status="success" text="启用" />;
              } else {
                return <a-badge status="error" text="禁用" />;
              }
            }
          },
          {
            title: "排序",
            dataIndex: "Sort"
          },
          {
            title: "操作",
            dataIndex: "Id",
            width: 130,
            key: "action",
            fixed: "right",
            align: "center",
            scopedSlots: { customRender: "rowAction" }
          }
        ]
      }
    };
  },
  methods: {
    addGoods() {
      this.$refs.GoodsList.show();
    },
    getGoods(row) {
      this.WarehouseGoodsId = row.Id;
      this.WarehouseGoodsName = row.Name;
    },
    deGoods() {
      this.WarehouseGoodsId = "";
      this.WarehouseGoodsName = "";
    },
    beforeUpload(file) {
      const readers = new FileReader();
      readers.readAsDataURL(file);
      readers.onload = e => {
        file.thumbUrl = e.target.result;
      };
      return false;
    },
    onChange(info) {
      const formData = new FormData();
      formData.append("file", info.file);
      formData.append("dataId", this.infoId);
      this.$post("RMS_QuickPicSave", formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }).then(res => {
        this.ImageUrl = res.Data;
      });
    },
    onSubmitBefore(values) {
      values.ImageUrl = this.ImageUrl;
      if (values.IsPack) {
        // 套餐
        const foodList = this.$refs.foodPackSelect.getData();
        if (!foodList.length) {
          this.$message.error("请选择套餐菜品");
          return false;
        }
        values.PackDetails = foodList;
      }
      let attr = 0;
      if (values.Attributes && values.Attributes.length) {
        values.Attributes.forEach(el => {
          attr += el;
        });
      }
      values.Attributes = attr;
      values.WarehouseGoodsId = this.WarehouseGoodsId;
      return values;
    },
    viewPackDetail(item) {
      viewFoodPackModal({
        data: item.PackDetails
      });
    }
  }
};
</script>

<style lang="less" scoped>
.photo-img {
  width: 88px;
  height: 88px;
}
</style>
